<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-end">
            <div>
              <button
                [disabled]="loadingCompanies"
                [label]="'common.exportXls' | transloco"
                (click)="exportVisible = !exportVisible"
                pButton
                class="p-button-secondary md:mr-2"
                icon="pi pi-file-excel"
              ></button>
              <button
                (click)="filtersVisible = !filtersVisible"
                class="p-button-secondary"
                icon="pi pi-sliders-h"
                label=" {{'common.filters' | transloco}}"
                pButton>
              </button>
            </div>
          </div>
        </div>
        <p-treeTable #treeTable [value]="hierarchy">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">{{'attribute.name' | transloco}}</th>
              <th scope="col">{{'attribute.orgCode' | transloco}}</th>
              <th scope="col">{{'attribute.description' | transloco}}</th>
              <th scope="col">{{'attribute.organizationType' | transloco}}</th>
              <th scope="col" *ngIf="!this.authGuard.isECommerce()">{{'attribute.numberOfMachines' | transloco}}</th>
              <th scope="col" *ngIf="!this.authGuard.isECommerce()">{{'attribute.totalSqueezedFruits' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr *ngIf="!loadingCompanies">
              <td>
                <div class="flex">
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  <span style="line-height: 2 !important;">{{rowData.name}}</span>
                </div>
              </td>
              <td>{{rowData.orgCode}}</td>
              <td>{{rowData.description}}</td>
              <td>{{rowData.organizationType.name}}</td>
              <td *ngIf="!this.authGuard.isECommerce()">
                <span *ngIf="rowData.totalMachines">{{rowData.totalMachines | number: '' : this.language}}</span>
                <span *ngIf="!rowData.totalMachines">0</span>
              </td>
              <td *ngIf="!this.authGuard.isECommerce()">{{rowData.totalSqueezedFruits | number: '' : this.language}}</td>
            </tr>
            <tr *ngIf="loadingCompanies">
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height" *ngIf="!this.authGuard.isECommerce()"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height" *ngIf="!this.authGuard.isECommerce()"><p-skeleton height="1em"></p-skeleton></td>
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          appAutoFocus
          pInputText
          class="w-full"
          id="name"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="organizationType">{{'attribute.organizationType' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect
          [(ngModel)]="currentFilters.organizationTypesUuids"
          [placeholder]="'select.generic' | transloco"
          [filter]="true" filterBy="name" display="chip" styleClass="w-full" appendTo="body"
          [options]="organizationTypes"
          id="organizationType"
          optionLabel="name"
          optionValue="organizationTypeUuid"
        >
        </p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="parent">{{'attribute.organizationParent' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-treeSelect
          [(ngModel)]="organizationParent"
          [placeholder]="'select.generic' | transloco"
          [options]="hierarchyFilters"
          (onNodeSelect)="currentFilters.parentUuid=$event.node.data"
          appendTo="body"
          id="parent"
        ></p-treeSelect>
      </div>
    </div>
    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="!(
            currentFilters.name ||
            currentFilters.organizationTypesUuids ||
            organizationParent
          )"
        (onClick)="filtersVisible = false; applyFilters()"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); filtersVisible = false; applyFilters()"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>

<app-export-xls *ngIf="exportVisible"
                [content]="nodes"
                [organizationFilters]="currentFilters"
                [typeContent]="'ORGANIZATION'"
                [exportFileType]="ExportFileType.ANALYSIS_ORGANIZATIONS"
                [typeExport]="'XLSX'"
                [(visible)]="exportVisible">
</app-export-xls>
